import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from "react";
import Element from 'src/components/element';
import utils from 'src/components/utils';
import CustomDialog from 'src/components/custom_dialog';

function RecuperarSenha(props) {
  let page = utils.getPath(1);

  const [data, setData] = useState({ source: page });
  const [crud, setCrud] = useState({ changed: data, data: data });
  const [view, setView] = useState({});

  window.view = view;

  let token = new URLSearchParams(props.location.search).get("token");

  crud.changed.token = token;
  crud.data.token = token;
  let msg = utils.lng('msg_alterar_senha', 'ALTERAR SENHA');

  if (page === 'welcome') {
    msg = utils.lng('msg_cadastre_sua_senha', 'CADASTRE SUA SENHA PARA SEU PRIMEIRO ACESSO');
  }

  let login = {
    styleClass: 'ui-login-panel',
    elements: {
      left: {
        cols: 3,
        elements: {
          logo_ngs: { type: 'img', value: 'static/img/logo_ngs.png', center: true }
        }
      },
      center: {
        cols: 6,
        elements: {
          logar: {
            type: "form",
            elements: {
              msg: { style: { color: '#fff', textAlign: 'center',paddingBottom: '15px' }, bold: true, value: msg },
              logo: { type: 'img', value: 'static/img/logo_login.png', center: true },
              digiteSenha: { type: 'password', label: utils.lng('senha','Senha'), name: 'digiteSenha', title: utils.lng('digite_sua_senha','Digite sua senha') },
              confirmeSenha: { type: 'password', label: utils.lng('confirmar','Confirmar'), name: 'confirmeSenha', title: utils.lng('confirmar_senha','Confirmar senha') },
              confirmar: {
                type: 'button', label: 'CONFIRMAR', icon: '', theme: 'secondary', styleClass: 'ui-btn-login',
                click: {
                  url: 'alterarSenha',
                  redirect: '/login',
                  method: 'POST'
                }
              },
              voltar: { rendered: "${@this.source !== 'welcome'}", type: 'link', value: 'voltar', style: { color: '#fff', textAlign: 'center' }, href: 'esqueci_senha' }
            }
          }
        }
      }, right: {
        cols: 3
      }
    }
  };
  return (
    <>
      <CustomDialog />
      <Element crud={crud} value={login} data={data} user={data} />
    </>
  );
}

export default RecuperarSenha;